<template>
  <section class="sec sec-9 mt-5 sec-padding">
    <div class="container-fluid">
      <div class="row">
        <div class="sec-title">
          <h1 class="has-u-line" v-html="title"> </h1>
        </div>
      </div>
      <div class="row justify-content-center mt-5 sec-9-box">
        <div class="col-lg-8">
            <div class="row mb-4">
                <div class="col-lg-4"><p>Opportunities</p></div>
                <div class="col-lg-3"><p>Preferred Experience</p></div>
                <div class="col-lg-3"><p>Location</p></div>
            </div>
            <div class="row jd-item" v-for="item in opportunitiesList" :key="item.title">
                <div class="col-lg-4"><h4 v-html="item.title"></h4></div>
                <div class="col col-lg-3"><p><b v-html="item.exp"></b> </p></div>
                <div class="col"><p><b v-html="item.loc"></b></p></div>
                <div class="col"><a target="_blank" href="https://blog.alphaq.ai/apply-now/"> Apply Now</a></div>
            </div>
        </div>
      </div>
    </div>
    
  </section>
</template>
<script>
export default {
   props: {
    title: {
      type: String,
      default: ""
    },
    titleSub:{
      type: String,
      default: ""
    }
  },
   data(){
    return{
        opportunitiesList:[
            { title: "Python/Quant Developer" ,  exp:"3+ Years" , loc:"Kochi, India"},
            { title: "Frontend Developer" ,  exp:"5 years" , loc:"Kochi, India"},
            { title: "Trading Analyst" ,  exp:"2+ years" , loc:"USA"},
            {title:"Research Technology Engineer",  exp:"2+ years" , loc:"USA"},
            {title:"Research Technology Developer",  exp:"2+ years" , loc:"USA"},
            { title: "AI Engineer" ,  exp:"1+ years" , loc:"Kochi, India"},
            { title: "AI Intern" ,  exp:"1+ years" , loc:"Kochi, India"},
            { title: "Digital Marketing intern" ,  exp:"6+ months" , loc:"Kochi, India"},
            { title: "HR/Business Development Manager" ,  exp:"2+ years" , loc:"Kochi, India"},
        ]
    }
   }
}
</script>